export default __webpack_public_path__ + "static/media/google.6f1394b0.svg";